import { AnyAction, Dispatch } from "redux";
import { handleActionError } from "src/common/actions/actionErrorHandler";
import { actionTypeKeys } from "./actionTypeKeys";
import ExternalSurveyApi from "../api/surveyApi";
import { AppointmentSurveyDto } from "../../external/types/appointmentSurvey";
import mask from "src/common/utilities/sensitiveDataMask";

export const getAppointmentSurveySuccess = (apptSurvey: AppointmentSurveyDto): AnyAction => {
  return {
    type: actionTypeKeys.GET_APPT_SURVEY_SUCCESS,
    payload: apptSurvey
  };
};

export const patchAppointmentSurveySuccess = (apptSurvey: AppointmentSurveyDto): AnyAction => {
  return {
    type: actionTypeKeys.PATCH_APPT_SURVEY_SUCCESS,
    payload: apptSurvey
  };
};

export const getAppointmentSurveyForAppointment = (apptId: number, dispatchError: boolean = true) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      let apptSurvey = await ExternalSurveyApi.getAppointmentSurveyForAppointment(apptId);
      dispatch(getAppointmentSurveySuccess(apptSurvey));
      return true;
    } catch (error) {
      handleActionError(error, dispatch, dispatchError);
      return false;
    }
  };
};

export const patchAppointmentSurvey = (apptSurvey: AppointmentSurveyDto, dispatchError: boolean = true) => {
  // handle potentially sensitive data
  let maskedFreeTextResponse = mask(apptSurvey.freeTextResponse);
  apptSurvey.freeTextResponse = maskedFreeTextResponse;
  // then send it on to the backend
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const response = await ExternalSurveyApi.patchAppointmentSurvey(apptSurvey);
      dispatch(patchAppointmentSurveySuccess(response));
      return true;
    } catch (error) {
      handleActionError(error, dispatch, dispatchError);
      return false;
    }
  };
};
